import React, { useState } from "react";
import { Box, Button, TextField, Typography, Alert } from "@mui/material";
import axiosInstance from "../api/axios";

const ResetPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axiosInstance.post("/users/reset-password", { email });
      setMessage("אם כתובת האימייל רשומה במערכת, יישלח קישור לאיפוס הסיסמה.");
    } catch (err) {
      setMessage("אירעה שגיאה. אנא נסה שוב.");
    }
  };

  return (
    <Box
      sx={{
        maxWidth: "400px",
        margin: "auto",
        mt: 5,
        p: 3,
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        borderRadius: 2,
        backgroundColor: "#fff",
        textAlign: "center",
        direction: "rtl", // מגדיר כיוון מימין לשמאל
      }}
    >
      <Typography variant="h4" gutterBottom>
        איפוס סיסמה
      </Typography>
      {message && (
        <Alert severity="info" sx={{ mb: 2 }}>
          {message}
        </Alert>
      )}
      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          label="אימייל"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          margin="normal"
          inputProps={{ style: { textAlign: "right" } }}
        />
        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 2, backgroundColor: "#1976d2" }}
        >
          שלח קישור לאיפוס
        </Button>
      </form>
    </Box>
  );
};

export default ResetPassword;
